var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("normalDialog", {
    attrs: {
      title: _vm.$t("label_essweb_Announcement_form_dialog_hasBeenReadLabel"),
      dialog: _vm.show,
      width: "800",
    },
    on: { close: _vm.closeDialog },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "v-container",
              { staticClass: "pa-0 ma-0", attrs: { fluid: "" } },
              [
                _c("v-data-iterator", {
                  attrs: {
                    items: _vm.desserts,
                    page: _vm.page,
                    "items-per-page": _vm.itemsPerPage,
                    "hide-default-footer": "",
                    "footer-props": {
                      "items-per-page-options": [10, 20, 50],
                      "items-per-page-text": _vm.$t(
                        "label_essweb_list_components_pagenations_perpageLabel"
                      ),
                    },
                  },
                  on: {
                    "update:page": function ($event) {
                      _vm.page = $event
                    },
                    "page-count": function ($event) {
                      _vm.$tableSetting.pageCount = $event
                    },
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "no-data",
                      fn: function () {
                        return [_c("noContent")]
                      },
                      proxy: true,
                    },
                    {
                      key: "header",
                      fn: function () {
                        return [
                          _c(
                            "v-toolbar",
                            {
                              staticClass:
                                "mb-2 px-0 mx-0 d-flex flex-row justify-start",
                              attrs: { flat: "" },
                            },
                            [
                              _c(
                                "v-sheet",
                                {
                                  staticClass:
                                    "d-flex flex-row align-center mr-2 ml-n6",
                                  on: {
                                    click: function ($event) {
                                      _vm.isAll == 0
                                        ? ((_vm.curType = 2),
                                          (_vm.isAll = 1),
                                          (_vm.isRead = 0),
                                          (_vm.notRead = 0))
                                        : null
                                    },
                                  },
                                },
                                [
                                  _c("v-rating", {
                                    staticClass: "mx-2",
                                    attrs: {
                                      size: "25",
                                      readonly: "",
                                      "background-color": "primary ",
                                      color: "primary",
                                      "empty-icon": "radio_button_unchecked",
                                      "full-icon": "radio_button_checked",
                                      length: 1,
                                      dense: "",
                                    },
                                    model: {
                                      value: _vm.isAll,
                                      callback: function ($$v) {
                                        _vm.isAll = $$v
                                      },
                                      expression: "isAll",
                                    },
                                  }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "label_essweb_Announcement_form_dialog_allReadLabel"
                                        )
                                      ) +
                                      "(" +
                                      _vm._s(_vm.totalCount_all) +
                                      ") "
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-sheet",
                                {
                                  staticClass:
                                    "d-flex flex-row align-center mx-2",
                                  on: {
                                    click: function ($event) {
                                      _vm.isRead == 0
                                        ? ((_vm.curType = 1),
                                          (_vm.isAll = 0),
                                          (_vm.isRead = 1),
                                          (_vm.notRead = 0))
                                        : null
                                    },
                                  },
                                },
                                [
                                  _c("v-rating", {
                                    staticClass: "mx-2",
                                    attrs: {
                                      size: "25",
                                      readonly: "",
                                      "background-color": "primary ",
                                      color: "primary",
                                      "empty-icon": "radio_button_unchecked",
                                      "full-icon": "radio_button_checked",
                                      length: 1,
                                      dense: "",
                                    },
                                    model: {
                                      value: _vm.isRead,
                                      callback: function ($$v) {
                                        _vm.isRead = $$v
                                      },
                                      expression: "isRead",
                                    },
                                  }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "label_essweb_Announcement_form_dialog_hasReadedLabel"
                                        )
                                      ) +
                                      "(" +
                                      _vm._s(_vm.totalCount_read) +
                                      ") "
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-sheet",
                                {
                                  staticClass:
                                    "d-flex flex-row align-center mx-2",
                                  on: {
                                    click: function ($event) {
                                      _vm.notRead == 0
                                        ? ((_vm.curType = 0),
                                          (_vm.isAll = 0),
                                          (_vm.isRead = 0),
                                          (_vm.notRead = 1))
                                        : null
                                    },
                                  },
                                },
                                [
                                  _c("v-rating", {
                                    staticClass: "mx-2",
                                    attrs: {
                                      size: "25",
                                      readonly: "",
                                      "background-color": "primary ",
                                      color: "primary",
                                      "empty-icon": "radio_button_unchecked",
                                      "full-icon": "radio_button_checked",
                                      length: 1,
                                      dense: "",
                                    },
                                    model: {
                                      value: _vm.notRead,
                                      callback: function ($$v) {
                                        _vm.notRead = $$v
                                      },
                                      expression: "notRead",
                                    },
                                  }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "label_essweb_Announcement_form_dialog_notReadLabel"
                                        )
                                      ) +
                                      "(" +
                                      _vm._s(_vm.totalCount_not) +
                                      ") "
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "default",
                      fn: function (props) {
                        return [
                          _c(
                            "v-row",
                            _vm._l(props.items, function (item) {
                              return _c(
                                "v-col",
                                {
                                  key: item.staff_uuid,
                                  attrs: {
                                    cols: "12",
                                    xm: "12",
                                    sm: "6",
                                    md: "6",
                                    lg: "6",
                                    xl: "6",
                                  },
                                },
                                [
                                  _c(
                                    "v-card",
                                    {
                                      staticClass:
                                        "mrc-border-solid pa-3 py-0 rounded",
                                      attrs: { elevation: 0, tile: "" },
                                    },
                                    [
                                      item.staff
                                        ? _c(
                                            "v-list-item",
                                            {
                                              staticClass: "pa-0",
                                              attrs: {
                                                dense: "",
                                                "two-line": "",
                                              },
                                            },
                                            [
                                              _c(
                                                "v-list-item-avatar",
                                                {
                                                  staticClass: "mr-1 my-0",
                                                  attrs: { size: "36" },
                                                },
                                                [
                                                  _c("StaffAvatar", {
                                                    attrs: {
                                                      size: "36",
                                                      src: item.staff
                                                        .staff_avatar,
                                                      staff_name:
                                                        item.staff
                                                          .preferred_name,
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-list-item-content",
                                                [
                                                  _c(
                                                    "v-list-item-title",
                                                    {
                                                      staticClass:
                                                        "table-title text--primary",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$getCommonLangValue(
                                                              item.staff
                                                                .preferred_name
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "text--secondary text-caption-xs",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                item.staff
                                                                  .staff_code
                                                              )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "v-list-item-subtitle",
                                                    {
                                                      staticClass:
                                                        "table-subtitle text--secondary",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$getCommonLangValue(
                                                              item.staff
                                                                .job_post_name
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-list-item-action",
                                                [
                                                  Number(item.read_flag)
                                                    ? _c("svg-icon", {
                                                        attrs: {
                                                          size: "24",
                                                          fill: "transparent",
                                                          iconClass: "Done",
                                                        },
                                                      })
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                        ]
                      },
                    },
                    {
                      key: "footer",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            [
                              _c("v-divider"),
                              _c(
                                "v-sheet",
                                {
                                  staticClass:
                                    "\n                pa-2\n                pb-0\n                max-width\n                d-flex\n                flex-nowrap\n                align-center\n                justify-space-between\n              ",
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "text-caption text--secondary",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.other) +
                                          " " +
                                          _vm._s(
                                            _vm.$t(
                                              "label_essweb_list_components_pagenations_columnLabel"
                                            )
                                          ) +
                                          "(" +
                                          _vm._s(
                                            _vm.$t(
                                              "label_essweb_list_components_pagenations_totalLabel"
                                            )
                                          ) +
                                          " " +
                                          _vm._s(_vm.totalCount) +
                                          " " +
                                          _vm._s(
                                            _vm.$t(
                                              "label_essweb_list_components_pagenations_columnLabel"
                                            )
                                          ) +
                                          ") "
                                      ),
                                    ]
                                  ),
                                  _c("v-spacer"),
                                  _c("v-pagination", {
                                    staticClass:
                                      "text--primary d-inline-block text-truncate text-center",
                                    attrs: {
                                      color: "grey lighten-2 ",
                                      "prev-icon": "navigate_before",
                                      "next-icon": "navigate_next",
                                      length: Math.ceil(
                                        _vm.totalCount /
                                          (_vm.itemsPerPage == -1
                                            ? _vm.totalCount
                                            : _vm.itemsPerPage)
                                      ),
                                      "total-visible": 7,
                                    },
                                    model: {
                                      value: _vm.page,
                                      callback: function ($$v) {
                                        _vm.page = $$v
                                      },
                                      expression: "page",
                                    },
                                  }),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "text-caption text--secondary pr-1",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_list_components_pagenations_perpageLabel"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "v-menu",
                                    {
                                      attrs: { "offset-y": "", small: "" },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "activator",
                                          fn: function (ref) {
                                            var on = ref.on
                                            return [
                                              _c(
                                                "v-btn",
                                                _vm._g(
                                                  {
                                                    staticClass:
                                                      "\n                      mrc-border-solid\n                      text-capitalize\n                      pa-0\n                      white\n                      text-body-2\n                      d-flex\n                      justify-space-around\n                    ",
                                                    staticStyle: {
                                                      "border-color":
                                                        "rgba(0, 0, 0, 0.1) !important",
                                                      "border-radius": "6px",
                                                      "min-width": "60px",
                                                    },
                                                    attrs: {
                                                      width: "60",
                                                      height: "28",
                                                      outlined: "",
                                                      depressed: "",
                                                      text: "",
                                                    },
                                                  },
                                                  on
                                                ),
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.itemsPerPage == -1
                                                          ? _vm.$t(
                                                              "label_essweb_list_components_pagenations_selectNumber_allLabel"
                                                            )
                                                          : _vm.itemsPerPage
                                                      ) +
                                                      " "
                                                  ),
                                                  _c(
                                                    "i",
                                                    {
                                                      staticClass:
                                                        "material-icons-round",
                                                    },
                                                    [_vm._v("arrow_drop_down")]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ]),
                                    },
                                    [
                                      _c(
                                        "v-list",
                                        { attrs: { dense: "" } },
                                        _vm._l(
                                          [10, 20, 50],
                                          function (item, index) {
                                            return _c(
                                              "v-list-item",
                                              {
                                                key: index,
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.setPerPage(item)
                                                  },
                                                },
                                              },
                                              [
                                                _c("v-list-item-title", [
                                                  _vm._v(
                                                    _vm._s(
                                                      item == -1
                                                        ? _vm.$t(
                                                            "label_essweb_list_components_pagenations_selectNumber_allLabel"
                                                          )
                                                        : item
                                                    )
                                                  ),
                                                ]),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                }),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _c("CardActions", {
              attrs: { okBtn: "", cancelBtn: false },
              on: { ok: _vm.closeDialog },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }